
<div class="manger_login_details">
    <app-background></app-background>
    <mat-card class="manger_login_card">
      <div class="manger_login_header">Manager Sign In</div>
      <div class="manger_login_header_data">Make your content broadcast easier and simple with sharkify.</div>
      <div class="page_details">
        
        <div class="form_field">
          <mat-form-field appearance="outline" class="manger_login_form_fields">
            <mat-label>Email ID</mat-label>
            <input matInput type="text"  [formControl]="Email" style="vertical-align: top; margin-left: 5px;">
            <mat-icon matSuffix style="color: var(--black-shade);">mail</mat-icon>
            <mat-error *ngIf="!Email.valid">
              {{getEmailError()}} 
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form_field">
          <mat-form-field appearance="outline" class="manger_login_form_fields">
            <mat-label>Password</mat-label>
            <input matInput [type]="p_hide ? 'password' : 'text'"
            [formControl]="Password">
            <button mat-icon-button matSuffix (click)="p_hide = !p_hide" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="p_hide">
              <mat-icon style="color: var(--black-shade);">{{p_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="!Password.valid">
              {{getPasswordError()}}
            </mat-error>
          </mat-form-field>
        </div> 
          <div *ngIf="ErrorLoggingIn" class="manger_login_error_message">
            {{LoginErrorMessage}}
          </div>
          <div style="float:right;margin-bottom: 10px;">
            <button class="manger_login_forgot" routerLink="/ForgotPassword">Forgot password?</button>
          </div>
          <div class="submit_button_wrap">
            <button class="manger_login_buttons" type="submit" (click)="managerSignIn()" >Sign In</button>
          </div>
          <div class="submit_button_wrap" style="padding: 10px 0px;">
            <div style="color: var(--black-shade);display: inline;font-family: var(--font);font-size: 18px ;letter-spacing: 1px; " >New to Sharkify ? </div>
             <div class="sigup_button"  routerLink="/ManagerRegistration"> Sign Up </div>
          </div>
  
        </div>
    </mat-card>
  </div>